import React from 'react';
import { Shield } from 'lucide-react';

interface DataTrustIndicatorProps {
  trustPercentage: number;
  sources: string[];
  resolvedConflicts?: number;
  totalConflicts?: number;
  attributeDefinitionsCount?: number;
  sourceComparisonCount?: number;
}

export const DataTrustIndicator: React.FC<DataTrustIndicatorProps> = ({
  trustPercentage,
  sources,
  attributeDefinitionsCount = 0,
  sourceComparisonCount = 0
}) => {
  const circumference = 2 * Math.PI * 28;
  const offset = circumference - (trustPercentage / 100) * circumference;

  const formatSourceName = (sourceName: string): string => {
    return sourceName
      .replace(/_/g, ' ')
      .toLowerCase()
      .replace(/\b\w/g, (letter) => letter.toUpperCase());
  };


  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Shield className="w-5 h-5 text-blue-600" />
          <h2 className="text-lg">Data Trust</h2>
        </div>
        <div className="flex items-center gap-6">
          <div className="flex items-center gap-3">
            <div className="relative w-16 h-16">
              <svg className="w-16 h-16 transform -rotate-90">
                <circle
                  cx="32"
                  cy="32"
                  r="28"
                  stroke="#e5e7eb"
                  strokeWidth="6"
                  fill="none"
                />
                <circle
                  cx="32"
                  cy="32"
                  r="28"
                  stroke="#2563eb"
                  strokeWidth="6"
                  fill="none"
                  strokeDasharray={circumference}
                  strokeDashoffset={offset}
                  strokeLinecap="round"
                />
              </svg>
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="text-sm">{trustPercentage}%</span>
              </div>
            </div>
            <div>
              <div className="text-sm text-gray-600">Trust Score</div>
              <div className="text-sm">{sourceComparisonCount} / {attributeDefinitionsCount} of resolved</div>
            </div>
          </div>
          {sources.length > 0 && (
            <div className="border-l border-gray-200 pl-6">
              <div className="text-sm text-gray-600 mb-2">Data Sources</div>
              <div className="flex flex-wrap gap-2">
                {sources.map((source, index) => (
                  <span
                    key={index}
                    className="px-3 py-1 bg-blue-50 text-blue-700 text-xs rounded-full border border-blue-200"
                  >
                    {formatSourceName(source)}
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
